// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles-module--icon--1GijV","externalLink":"styles-module--externalLink--3al0a"};